import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contractTerminationRequestSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

const params = (uuid: string) => {
  const url = API_ENDPOINTS.CONTRACT_TERMINATION_REQUEST.replace(':uuid', uuid)
  return {
    queryKey: [url],
    queryFn: () => get(url, contractTerminationRequestSchema),
  }
}

export const useAPIGetContractTerminationRequest = (contractUUID: string) =>
  useQuery(params(contractUUID))

export const useAPIGetContractTerminationRequestSuspense = (
  contractUUID: string
) => useSuspenseQuery(params(contractUUID))
